export const getSeconds = () => Math.round(+new Date() / 1e3);

export const getTimezone = () => -new Date().getTimezoneOffset();
